import React from 'react'

const Boots = () => {
  return (
    <div>Boots</div>
  )
}

export default Boots